
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "xmlns:a": "http://ns.adobe.com/AdobeSVGViewerExtensions/3.0/",
    "x": "0px",
    "y": "0px",
    "width": "33px",
    "height": "33px",
    "viewBox": "-0.979 -0.368 33 33",
    "enable-background": "new -0.979 -0.368 33 33",
    "xml:space": "preserve"
  },
  "children": [
    {
      "tag": "defs"
    },
    {
      "tag": "rect",
      "attrsMap": {
        "display": "none",
        "fill": "#F2F2F2",
        "width": "32",
        "height": "32"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "fill": "#999999",
        "d": "M15.999,7.046c5.154,0,9.373,4.218,9.373,9.373c0,5.154-4.219,9.373-9.373,9.373\r\n\tc-5.156,0-9.373-4.219-9.373-9.373C6.626,11.264,10.843,7.046,15.999,7.046 M15.999,5.537c-5.982,0-10.88,4.897-10.88,10.882\r\n\tc0,5.982,4.897,10.88,10.88,10.88c5.984,0,10.881-4.897,10.881-10.88C26.88,10.435,21.983,5.537,15.999,5.537L15.999,5.537z\r\n\t M15.999,4.702"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "fill": "#999999",
        "d": "M11.313,15.248h9.373c0.703,0,1.173,0.468,1.173,1.171c0,0.702-0.47,1.173-1.173,1.173h-9.373\r\n\tc-0.702,0-1.172-0.471-1.172-1.173C10.141,15.716,10.61,15.248,11.313,15.248L11.313,15.248z M11.313,15.248"
      }
    }
  ]
})
    }
  